<template>
  <div class="hot_div">
    <div class="hot_list">
      <div class="flex_between div_title">
        <div style="display:flex">
          <h4
            @click="chageid(1)"
            :class="{title:true,titleactive:activeti===1}"
            style="margin-right:30px"
          >文章关注</h4>
          <h4
            @click="chageid(2)"
            :class="{title:true,titleactive:activeti===2}"
          >视频关注</h4>
        </div>
        <div class="flex_center title_right">
          <span
            class="del"
            @click="del"
            v-if="activeti===1&&state"
          >取消关注</span>
          <span
            class="del"
            @click="delvedio"
            v-if="activeti===2&&state"
          >取消关注</span>
          <button
            class="flex_center"
            @click="state = !state"
            :class="{'state':state}"
          >
            <span v-if="!state">管理</span>
            <span v-else>取消</span>
          </button>
        </div>
      </div>
      <!-- 文章关注 -->
      <div
        class="list_ul flex_start"
        v-if="activeti===1&&list_ul.length>0"
      >
        <div
          class="list_li flex_center"
          :class="{'selsected':liem.is_selected&&state}"
          @click.stop="detailsFun(index,liem.id)"
          v-for="(liem,index) in list_ul"
          :key="liem.id"
        >
          <i
            class="gou_icon"
            v-if="state"
          >
            <img
              v-if="!liem.is_selected"
              src="@/assets/img/gou.png"
              alt=""
            >
            <img
              v-else
              src="@/assets/img/gouT.png"
              alt=""
            >
          </i>
          <i class="li_icon">
            <img
              v-if="liem.image"
              :src="liem.image"
              alt=""
            >
            <img
              v-else
              src="@/assets/img/app_logo.png"
              alt=""
            >
          </i>
          <h4>{{liem.title}}</h4>
        </div>

      </div>
      <!-- 视频关注 -->
      <div
        class="list_ul flex_start"
        v-if="activeti===2&&list_ul.length>0"
      >
        <div
          class="list_li flex_center"
          :class="{'selsected':liem.is_selected&&state}"
          @click.stop="detailsFun(index,liem.id)"
          v-for="(liem,index) in list_ul"
          :key="liem.id"
        >
          <i
            class="gou_icon"
            v-if="state"
          >
            <img
              v-if="!liem.is_selected"
              src="@/assets/img/gou.png"
              alt=""
            >
            <img
              v-else
              src="@/assets/img/gouT.png"
              alt=""
            >
          </i>
          <i class="li_icon" style="width:240px">
            <img
              v-if="liem.image"
              :src="liem.image"
              alt=""
            >
            <img
              v-else
              src="@/assets/img/app_logo.png"
              alt=""
            >
          </i>
          <h4>{{liem.title}}</h4>
        </div>

      </div>
      <div
        class="flex_center no_center"
        v-if="activeti===1&&list_ul.length===0"
      >
       <!-- src="@/assets/img/focus_icon.jpg -->
        <i v-if="is_loading"><img
            src="@/assets/img/kkry_pc.gif"
            alt=""
          ></i>
        <div
          class="flex_center prompt_text"
          v-if="is_loading"
        >
          暂无关注，前往推荐看看吧! <a
          v-if="activeti===1"
            href="javaScript:void(0)"
            @click.stop="geHome(1)"
          >推荐</a>
          <a
          v-if="activeti===2"
            href="javaScript:void(0)"
            @click.stop="geHome(2)"
          >推荐</a>
        </div>
        <div
          v-else
          class="flex_center prompt_text"
        >
          加载中...
        </div>
      </div>
      <div
        class="flex_center no_center"
        v-if="activeti===2&&list_ul.length===0"
      >
        <i v-if="is_loading"><img
            src="@/assets/img/kkry_pc.gif"
            alt=""
          ></i>
        <div
          class="flex_center prompt_text"
          v-if="is_loading"
        >
          暂无关注，前往推荐看看吧! <a
          v-if="activeti===1"
            href="javaScript:void(0)"
            @click.stop="geHome(1)"
          >推荐</a>
          <a
          v-if="activeti===2"
            href="javaScript:void(0)"
            @click.stop="geHome(2)"
          >推荐</a>
        </div>
        <div
          v-else
          class="flex_center prompt_text"
        >
          加载中...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'popup',
  data () {
    return {
      state: false,//管理状态
      user: {},//用户信息
      list_ul: [
        // {is_selected:false,},
        // {is_selected:false,},
        // {is_selected:false,},
        // {is_selected:false,}
      ],
      page: 1,
      is_loading: false,
      activeti: 1,
    }
  },
  props: {

  },
  watch: {

  },
  methods: {
    chageid (id) {
      this.activeti = id
      this.getList()
    },
    detailsFun (index,id) {
      if (this.state) {
        this.list_ul[index].is_selected = !this.list_ul[index].is_selected;
        this.reinstall();
      } else {
        if (this.list_ul[index].class === "video") {
          this.$router.push({ path: '/vedio_list', query: { cateid:id } });
        } else {
          this.$store.commit('setColumn', this.list_ul[index].id);
          this.$router.replace("/column");
        }
      }
    },
    del () {//删除关注
      let that = this;
      let arr = [];
      this.list_ul.forEach((liem, index) => {
        if (liem.is_selected) {
          arr.push(liem.id)
        }
      })
      if (arr.length > 0) {
        layer.open({
          content: '您确认取消这些关注吗？'
          , style: 'background-color:#fef0f0; color:#F56C6C;font-size:18px; border:none;' //自定风格
          , btn: ['确定', '取消']
          , yes: function (index) {
            layer.close(index);
            that.$post('follow', {
              conf_id: arr.join(","),
              member_id: that.USER().id,
              type: 2,
            }).then(res => {
              layer.open({
                content: "取消关注成功",
                time: true,
                skin: "msg"
              });
              that.state = false;
              that.page = 1;
              that.getList();
              that.$parent.beiChildMethod();
            })
          }
        })
      }

    },

    delvedio () {
      let that = this;
      let arr = [];
      this.list_ul.forEach((liem, index) => {
        if (liem.is_selected) {
          arr.push(liem.id)
        }
      })
      if (arr.length > 0) {
        layer.open({
          content: '您确认取消这些关注吗？'
          , style: 'background-color:#fef0f0; color:#F56C6C;font-size:18px; border:none;' //自定风格
          , btn: ['确定', '取消']
          , yes: function (index) {
            layer.close(index);
            that.$post('follow', {
              conf_id: arr.join(","),
              member_id: that.USER().id,
              type: 2,
              class: "video",
            }).then(res => {
              layer.open({
                content: "取消关注成功",
                time: true,
                skin: "msg"
              });
              that.state = false;
              that.page = 1;
              that.getList();
              that.$parent.beiChildMethod();
            })
          }
        })
      }

    },
    geHome: function (id) {
      if(id===1){
      this.$router.replace('/column');
      }else{
      this.$router.replace('/vedio');
      }
    },
    getList () {
      let that = this;
      if (this.page == 1) {
        this.list_ul = [];
      }
      this.$post('follow_comment', {
        type: 2,//1评论2关注3收藏
        member_id: this.USER().id,
      }).then(res => {
        that.is_loading = true;
        if (this.activeti === 1) {
          if (res.data) {
            res.data.news.forEach((element, index) => {
              res.data.news[index].is_selected = false;
            });
          }
          that.list_ul = res.data.news
        } else {
          if (res.data) {
            res.data.video.forEach((element, index) => {
              res.data.video[index].is_selected = false;
            });
          }
          that.list_ul = res.data.video
        }

      })
    },
    getUser () {
      let that = this;
      this.REFRESH_USER();
      that.user = this.USER();
      this.getList();
    },

  },
  mounted () {
    this.getUser();

    let that = this;
    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();

    });
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#index {
  min-width: 1280px;
}
.div_title {
  height: 48px;
  border-bottom: 1px solid #dfdfdf;
}

.div_title .title {
  font-size: 18px;
  color: #1a1a1a;
  margin-bottom: 20px;
  cursor: pointer;
}
.titleactive {
  color: #db414e !important;
}
.div_title .title_right > button {
  height: 36px;
  border-radius: 4px;
  background: #db414e;
  color: #fff;
  font-size: 18px;
  border: 0;
  margin-left: 50px;
  width: 88px;
}

.div_title .title_right > button.state {
  color: #1a1a1a;
  background: #dfdfdf;
}

.div_title .title_right .del {
  font-size: 18px;
  color: #f24d5b;
  cursor: pointer;
}

.list_ul {
  padding: 17px 0;
  width: calc(100% + 18px);
  flex-wrap: wrap;
}

.list_ul .list_li {
  width: calc(33% - 10px);
  height: 263px;
  border: 1px solid #999999;
  position: relative;
  flex-direction: column;
  display: inline-flex;
  border-radius: 10px;
  margin: 0 10px 10px 0;
  background: #fff;
  cursor: pointer;
  transition: all 0.5s ease;
}

.list_ul .list_li:hover {
  background: rgba(255, 114, 89, 0.4);
  border-color: #f24d5b;
}

.list_ul .list_li.selsected {
  border-color: #f24d5b;
}

.list_ul .list_li .gou_icon {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 28px;
  height: 28px;
}

.list_ul .list_li .li_icon {
  width: 110px;
  height: 110px;
  margin-bottom: 30px;
}

.list_ul .list_li > h4 {
  font-size: 31px;
  font-weight: bold;
  color: #f5ab16;
}

.no_center {
  flex-direction: column;
  padding-top: 72px;
}

.no_center > i {
  width: 300px;
  margin-bottom: 40px;
}

.no_center .prompt_text {
  font-size: 18px;
  color: #666;
}

.no_center .prompt_text > a {
  color: #f24d5b;
  margin-left: 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/pc_viwe/my_focus.vue